/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class PreSaleOrderApi {
    static getInstance() {
        if (!this.instance) this.instance = new PreSaleOrderApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取退货杂单列表
    // async getReturnOrderList (param, num, size){
    //     let url = `/api/order/back/record/list?page_num=${num}&page_size=${size}`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }

    // 上传文件并填写基础信息
    async importFile (param){
        let url = `/api/order/pre/order/import/fixed`
        let result = await this.getData(url,param,'POST','application/form-data')
        return result
    }

    // 用户确认信息
    async confirmInfo (param){
        let url = `/api/order/pre/order/import/confirm/fixed`
        let result = await this.getData(url, param, 'POST','multipart/form-data')
        return result
    }

    // 获取支付方式下拉配置
    async getPaymentTypeConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取支付折扣下拉配置
    async getPayDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取现金折扣下拉配置
    async getCashDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取支付方式可选账期下拉配置
    async getPayDayConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取税率
    async getTax (){
        let url = `/api/system/dictionary/tax`
        let result = await this.getData(url,{},'GET')
        return result
    } 

    // 获取渠道
    async getSource (param){
        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取经销商对应的客户
    async getCustomer (param){
        let url = `/api/customer/entity/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取客户地址
    async getCustomerAddressList (param){
        let url = `/api/customer/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载模板
    async downloadTemplate (param, category){
        let url = `/api/order/module/download/${category}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取文件编号
    async getFileNo (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 
}

export {
    PreSaleOrderApi
}